import { render, staticRenderFns } from "./IndustryChip.vue?vue&type=template&id=71606b07&scoped=true"
import script from "./IndustryChip.vue?vue&type=script&lang=js"
export * from "./IndustryChip.vue?vue&type=script&lang=js"
import style0 from "./IndustryChip.vue?vue&type=style&index=0&id=71606b07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71606b07",
  null
  
)

export default component.exports